module.exports = __webpack_public_path__ + "d64c4ae257c5427786431b141f940a91.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/minimal-wave.jpg
 ** module id = 443
 ** module chunks = 0
 **/